import React from 'react';

/**
 * Termin (süre) göstergeleri için ortak yardımcılar.
 *
 * Termin sütunlarının ipucu metni daha önce her ekranda ayrı yazılıyordu ve
 * hepsi kuru bir "Termin: 7 gün (+1 gün ek hak)" gösteriyordu — yani sayaç
 * hangi tarihten başlıyor görünmüyordu. Artık işin NE ZAMAN atandığı ve varsa
 * ara tarihler (adım başlangıcı, son taşıma …) ipucunda listeleniyor.
 */

/** Termin dolduktan sonra tanınan ek hak (gün). */
export const TERMIN_HAK = 1;

/**
 * Tarih + saat biçimlendirir. Saat 00:00 ise kaynak DATE kolonudur, saat
 * gösterilmez. Geçersiz / sıfır tarihler (`0000-00-00` → 1899) elenir.
 */
export const formatDateTime = (value) => {
  if (!value) return null;
  const d = new Date(value);
  if (isNaN(d.getTime()) || d.getFullYear() < 1990) return null;
  const saat = d.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
  return saat === '00:00'
    ? d.toLocaleDateString('tr-TR')
    : `${d.toLocaleDateString('tr-TR')} ${saat}`;
};

/**
 * Termin sütunu ipucu içeriği.
 *
 * @param {Array<[string, any]>} tarihler - [etiket, değer] çiftleri; boş/geçersiz
 *   olanlar atlanır. İlk sıradaki genelde "Görev alındı" olmalıdır.
 * @param {number} terminGun - bu satır için geçerli termin süresi
 * @param {number} [terminHak=TERMIN_HAK]
 */
export const terminIpucu = (tarihler, terminGun, terminHak = TERMIN_HAK) => {
  const satirlar = [];
  (tarihler || []).forEach(([etiket, deger]) => {
    const metin = formatDateTime(deger);
    if (metin) satirlar.push(`${etiket}: ${metin}`);
  });
  if (!satirlar.length) satirlar.push('Tarih bilgisi yok');
  // Ek hak tanımlı olmayan ekranlarda "(+0 gün ek hak)" yazmayalım.
  satirlar.push(
    terminHak > 0
      ? `Termin: ${terminGun} gün (+${terminHak} gün ek hak)`
      : `Termin: ${terminGun} gün`
  );
  return <div style={{ whiteSpace: 'pre-line' }}>{satirlar.join('\n')}</div>;
};

export default { TERMIN_HAK, formatDateTime, terminIpucu };
